import { map } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { DetailsSidebarAction } from '@cbridge-packages/details-sidebar';
import { OrderLifetimeAction } from '@cbridge-packages/order-lifetime';

export const toggleViewPricingProfileSidebarEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(
    OrderLifetimeAction.update.done,
  ),
  map(() => {
    return DetailsSidebarAction.toggleEdit();
  }),
);
